import(/* webpackMode: "eager" */ "/var/www/dev-716-cannabis/app/shop/category/apparel/page.tsx");
